export const meterInfoStateBaseLabel = 'ENERGY.METER_READING.STATE';
